import { render } from "./PastProjects.vue?vue&type=template&id=07757ec8"
import script from "./PastProjects.vue?vue&type=script&lang=js"
export * from "./PastProjects.vue?vue&type=script&lang=js"

import "./PastProjects.vue?vue&type=style&index=0&id=07757ec8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__